<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWrapClassName="etikett-fullscreen-modal"
  nzWidth="100vw"
  [nzStyle]="{ top: '0', paddingBottom: '0', maxWidth: '100vw', margin: '0' }"
  [nzBodyStyle]="{ height: 'calc(100vh - 110px)', padding: '0', overflow: 'hidden' }"
>
  <ng-template #modalTitle>
    {{ isNew ? 'Neu ' + articleLabelTypesDisplayNames[labelType] + ' Etiketten erstellen' : 'Bearbeiten ' + articleLabelTypesDisplayNames[object.type] + ' Etiketten' }}
  </ng-template>

  <ng-template #modalContent>
    <app-add-edit-round-label-form
      #form
      [editObject]="object"
      (formFinished)="onFormFinished($event)"
      [labelType]="labelType"
      [article]="article"
      [articleVariantIds]="articleVariantIds"
    />
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>
